import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { mediaQueries } from '@general/breakpoints';

const CardImageStyled = styled.img`
    border-radius: 100%;
    height: ${props => props.sizeMobile}px;
    width: ${props => props.sizeMobile}px;

    @media ${mediaQueries.md} {
        height: ${props => props.sizeDesktop}px;
        width: ${props => props.sizeDesktop}px;
    }
`;

const CardCompanyAvatar = ({ name, photoURL, sizeMobile = 80, sizeDesktop = 180 }) => (
    <>
        {!photoURL && (
            <CardImageStyled
                src="/assets/images/company-default.svg"
                alt={name}
                sizeMobile={sizeMobile}
                sizeDesktop={sizeDesktop}
            />
        )}

        {photoURL && <CardImageStyled src={photoURL} alt={name} sizeMobile={sizeMobile} sizeDesktop={sizeDesktop} />}
    </>
);

CardCompanyAvatar.propTypes = {
    name: PropTypes.string,
    photoURL: PropTypes.string,
    sizeMobile: PropTypes.number,
    sizeDesktop: PropTypes.number,
};

export default CardCompanyAvatar;
